/**
 * MiScriptBuilder.vue
 * The main app template.  Shows the form and outputs the script as items are changed.
 */
<template>
    <div id="mi-script-builder" class="row">
        <h3>Customize {{ this.$config.sites[this.$config.moniker].moniker_display_name }}</h3>
       
        {{ sample_script }} 
    
        <ul class="nav ml-auto flex-nowrap col-12">
            
            <div @click="toggleShowButtonBackgroundColor()" style="margin-right: 15px; cursor: pointer;">
                <i style="padding: 3px" class="ti-paint-bucket"></i><span class="notifications">Button Background Color</span>
            </div>
            <div v-if="showButtonBackgroundColor" style="position: absolute; left: 0; top: 35px; z-index: 99999">
                <div>
                    <color-picker
                        v-model="data_attibutes['data-buttonBackgroundColor']"
                        @input="setButtonBackgroundColor"
                    ></color-picker>
                </div>
            </div>


            <div @click="toggleShowButtonTextColor()" style="cursor: pointer">
                <i style="padding: 3px" class="ti-paint-bucket"></i><span class="notifications">Button Text Color</span>
            </div>
            <div v-if="showButtonTextColor" style="position: absolute; left: 200px; top: 35px; z-index: 99999">
                <div>
                    <color-picker
                        v-model="data_attibutes['data-buttonTextColor']"
                        @input="setButtonTextColor"
                    ></color-picker>
                </div>
            </div>


        </ul>

        <div class="col-12">
            <hr>
        </div>

        <div class="col-12">
            <div
                id=""
                class="browser-frame"
            >
                <div class="bf-container">

                    <div class="top d-flex justify-content-between col-12">
                        <div><span class="dot"></span>
                            <span class="dot"></span>
                            <span class="dot"></span>
                        </div>
                        <div class="d-flex align-items-center code-controls">
                            <div
                                class="p-2"
                                :class="activeView == 'preview' ? 'active' : ''"
                                @click="showPreview()"
                            ><i class="ti-desktop"></i> Preview</div>
                            <div
                                class="p-2"
                                :class="activeView == 'getcode' ? 'active' : ''"
                                @click="showCode()"
                            ><i class="ti-layers"></i> Code</div>
                        </div>
                    </div>

                    <div
                        class="bf-content col-12"
                        style="position: relative; height: 500px;"
                    >
                        <div
                            id="msb-preview"
                            v-show="activeView == 'preview'"
                        ></div>
                        <div
                            class="position-relative"
                            v-show="activeView == 'getcode'"
                        >
<pre
    id="msb-script"
    class="language-html"
><code>/*--- Missingink Shop Embed Code ---*/
{{open_script_tag}}
    src="{{scriptURL}}"
    data-mistore="{{store_moniker}}"{{data_attibutes_string}}
{{close_script_tag}}
</code></pre>
                            <button
                                class="btn position-absolute"
                                style="right: 0; bottom: -18px;"
                                id="msb-copy"
                                data-clipboard-target="#msb-script"
                            > <i class="ti-clipboard"></i> Copy code</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Clipboard from "clipboard";
import { Chrome } from "vue-color";
import _debounce from "lodash.debounce";

export default {
    name: "MiScriptBuilder",
    props: {
        moniker: {
            required: false,
            default: "",
        },
    },
    components: {
        "color-picker": Chrome,
    },
    data: function () {
        return {
            stores: {},
            store_moniker: this.$config.moniker,
            data_attibutes: {
                "data-buttonBackgroundColor": "#58559E",
                "data-buttonTextColor": "#dfdfdf",
            },
            open_script_tag: '\<script',
            close_script_tag: '\>\<\/script\>',
            previewContainer: null,
            apiURL: "https://shopify.missingink.com/api/v1/stores",
            scriptURL: "//assets.missingink.com/js/mi-js-store/mistore.min.js",
            activeView: 'preview',
            showButtonTextColor: false,
            showButtonBackgroundColor: false,
        };
    },
    computed: {
        data_attibutes_string: function () {
            var toString = "";
            for (var key in this.data_attibutes) {
                toString +=
                    "\n" + "    " + key + '="' + this.data_attibutes[key] + '"';
            }
            return toString;
        },
        sample_script: function () {
            console.log([this.store_moniker, this.previewContainer]);

            //this much is required
            if (this.store_moniker === "" || this.previewContainer === null)
                return null;

            //remove current script if it exists
            var currentScript = document.querySelector("#msb-preview-js");

            if (currentScript !== null)
                this.previewContainer.removeChild(currentScript);
            console.log("cs: " + currentScript);

            //remove current store html if it exists.
            var currentStore = document.querySelectorAll(
                ".mi-store-container.mi-store"
            );

            if (currentStore.length > 0)
                this.previewContainer.removeChild(currentStore[0]);

            //create a new script and data variables
            var script = document.createElement("script");

            //set script attributes
            script.setAttribute("id", "msb-preview-js");
            script.setAttribute("data-mistore", this.store_moniker);
            this.set_script_attibutes(script);
            script.src = this.scriptURL;

            //load the script tag
            this.previewContainer.appendChild(script);

            return "";
        },
    },
    methods: {
        set_script_attibutes: function (script) {
            for (var key in this.data_attibutes) {
                script.setAttribute(key, this.data_attibutes[key]);
            }
            return script;
        },

        async get_stores() {
            const response = await fetch(this.apiURL);
            this.data = await response.json();
            this.stores = this.data.stores;
            this.loading = false;
        },

        initailizeClipboard: function (Clipboard, el) {
            //setup the copy button
            new Clipboard(el);
        },

        setPreviewContainer: function (el) {
            this.previewContainer = document.querySelector(el);
        },

        setButtonTextColor: _debounce(function (val) {
            this.data_attibutes["data-buttonTextColor"] =
                this.data_attibutes["data-buttonTextColor"].hex;
        }, 100),
        setButtonBackgroundColor: _debounce(function (val) {
            this.data_attibutes["data-buttonBackgroundColor"] = val.hex;
        }, 100),

        toggleShowButtonTextColor: function () {
            this.showButtonTextColor = !this.showButtonTextColor;
        },
        
        toggleShowButtonBackgroundColor: function () {
            this.showButtonBackgroundColor = !this.showButtonBackgroundColor;
        },

        showPreview() {
            this.activeView = "preview";
        },

        showCode() {
            this.activeView = "getcode";
        },
    },

    mounted: function () {
        //get the store listing
        this.$nextTick(this.get_stores);

        //setup the clipboard
        this.$nextTick(
            this.initailizeClipboard.bind(this, Clipboard, "#msb-copy")
        );

        //get the preview container
        this.$nextTick(this.setPreviewContainer.bind(this, "#msb-preview"));
    },
};
</script>

<style>
#mi-script-builder .dropdown-toggle > i {
    padding-right: 4px;
}

#mi-script-builder .vue-color__editable-input__label,
#mi-script-builder .vue-color__chrome__toggle-btn {
    display: none !important;
}
#mi-script-builder .vue-color__chrome {
    box-shadow: none;
    border: 1px solid #efefef;
}

@media (min-width: 699px) {
    #mi-script-builder {
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
    }

    #mis-header {
        width: 100%;
        text-align: center;
        flex: 1 100%;
    }

    #mi-code {
        width: auto;
        flex: 12 auto;
        max-width: none;
    }
}

#msb-viewer {
    position: relative;
    padding: 30px 10px 125% 10px;
    border-style: solid;
    border-width: 60px 10px;
    border-color: #2b2b2b;
    margin: 0 20px;
}

#msb-viewer:before {
    content: "";
    display: block;
    height: 10px;
    width: 10px;
    border-radius: 100%;
    background-color: #505050;
    position: absolute;
    top: -35px;
    left: 50%;
    transform: translateX(-50%);
}

#msb-preview {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    overflow: scroll;
    padding: 10px;
}

@media (min-width: 699px) {
    #msb-viewer {
        padding: 30px 30px 50% 30px;
        border-width: 30px 30px 45px 30px;
        border-radius: 0;
        border-top-left-radius: 50px;
        border-top-right-radius: 50px;
        margin: 0 auto;
    }
}

#msb-script {
    padding: 10px;
    text-align: left;
    font-size: 15px;
    line-height: 1.5;
    margin: 20px auto;
    word-wrap: break-word;
    overflow-x: scroll;
    background: #f4f5f6;
    padding: 25px;
}

/*---*/

.browser-frame {
    box-shadow: 10px 10px 0 #333;
    width: calc(100% - 10px);
}

.browser-frame .dot {
    height: 12px;
    width: 12px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
    margin-right: 6px;
    margin-top: 10px;
}

.browser-frame .code-controls .active {
    color: #06aeef;
}

.browser-frame .bf-container {
    border: 3px solid #f1f1f1;
}

.browser-frame .top {
    padding: 5px 10px;
    background: #f1f1f1;
}

.browser-frame .bf-content {
    padding: 10px;
}
.storefront__cart-link {
    display: none !important;
}
</style>

<!--<style scoped lang="postcss" src="_scoped.css"></style>-->
